// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/iam/v1/authorization.proto" (package "c1.api.iam.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.iam.v1.ActorObjectPermissions
 */
export interface ActorObjectPermissions {
    /**
     * @generated from protobuf field: bool read = 1
     */
    read: boolean;
    /**
     * @generated from protobuf field: bool edit = 2
     */
    edit: boolean;
    /**
     * @generated from protobuf field: bool delete = 3
     */
    delete: boolean;
    /**
     * @generated from protobuf field: map<string, bool> extra = 4
     */
    extra: {
        [key: string]: boolean;
    };
}
// @generated message type with reflection information, may provide speed optimized methods
class ActorObjectPermissions$Type extends MessageType<ActorObjectPermissions> {
    constructor() {
        super("c1.api.iam.v1.ActorObjectPermissions", [
            { no: 1, name: "read", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "edit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "delete", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "extra", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 8 /*ScalarType.BOOL*/ } }
        ]);
    }
    create(value?: PartialMessage<ActorObjectPermissions>): ActorObjectPermissions {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.read = false;
        message.edit = false;
        message.delete = false;
        message.extra = {};
        if (value !== undefined)
            reflectionMergePartial<ActorObjectPermissions>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActorObjectPermissions): ActorObjectPermissions {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool read */ 1:
                    message.read = reader.bool();
                    break;
                case /* bool edit */ 2:
                    message.edit = reader.bool();
                    break;
                case /* bool delete */ 3:
                    message.delete = reader.bool();
                    break;
                case /* map<string, bool> extra */ 4:
                    this.binaryReadMap4(message.extra, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap4(map: ActorObjectPermissions["extra"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ActorObjectPermissions["extra"] | undefined, val: ActorObjectPermissions["extra"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.bool();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.iam.v1.ActorObjectPermissions.extra");
            }
        }
        map[key ?? ""] = val ?? false;
    }
    internalBinaryWrite(message: ActorObjectPermissions, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool read = 1; */
        if (message.read !== false)
            writer.tag(1, WireType.Varint).bool(message.read);
        /* bool edit = 2; */
        if (message.edit !== false)
            writer.tag(2, WireType.Varint).bool(message.edit);
        /* bool delete = 3; */
        if (message.delete !== false)
            writer.tag(3, WireType.Varint).bool(message.delete);
        /* map<string, bool> extra = 4; */
        for (let k of globalThis.Object.keys(message.extra))
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Varint).bool(message.extra[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.iam.v1.ActorObjectPermissions
 */
export const ActorObjectPermissions = new ActorObjectPermissions$Type();
